import Vue from 'vue';
import Component from 'vue-class-component';
import art from '../../../static/js/proto/art/Art.js';
import model from '../../../static/js/proto/Model.js';
import front from '../../../static/js/proto/CtpFront.js';
import { postForm } from '@/utils/CrmHttp';

@Component({
})

export default class Person extends Vue {
  /**
   * 个人中心
   */
  public balance: string = '0.00';
  public available: string = '0.00';
  public currMargin: string = '0.00';
  public setting: SystemSettingModel = {} as any;
  public activated() {
    front.autoMount(art.bind(this, this.load));
    this.$store.commit('selectIndex', 4);
    if (!this.setting.CustomerServiceTel) {
      this.loadSetting();
    }
  }
  public deactivated() {
    model.trader.queryCapital.stop();
  }
  public goSet() {
    this.$router.push('/setPage');
  }
  // 充值
  public handleRecharge() {
    this.$router.push({ path: '/recharge' });
  }
  // 提现
  public handleDrawMoney() {
    this.$router.push({ path: '/drawmoney/' + this.available });
  }
  // 充值记录
  public handleRechargeRecord() {
    this.$router.push({ path: '/rechargerecord' });
  }
  // 提款记录
  public handleDrawMoneyRecord() {
    this.$router.push({ path: '/drawmoneyrecord' });
  }

  // 资金

  public load(onFail) {
    model.capital.attach('person', art.bind(this, this.onUpdateCapital));
    model.trader.queryCapital.start();

  }
  public async loadSetting() {
    try {
      this.setting = await postForm('/api/system/system-setting');
    } catch {
      this.setting = {} as any;
    }

  }
  public onUpdateCapital(capital) {
    if (capital === undefined) {
      this.balance = '0.0';
      this.available = '0.0';
      this.currMargin = '0.0';
      return;
    }
    this.balance = capital.balance.toFixed(2);
    this.available = capital.available.toFixed(2);
    this.currMargin = capital.currMargin.toFixed(2);
  }
}



// WEBPACK FOOTER //
// ./src/views/Person/Person.ts